import React from 'react';
import './InsuranceInfo.scss';

const InsuranceInfo: React.FC = () => {
  return (
    <div className="insurance-info-container">
      <div className="insurance-info-header">
        <h1>Insurance Accepted</h1>
      </div>

      <div className="insurance-info-content">
        <section className="insurance-intro-section">
          <p className="intro-text">Please feel free to give us a call at <a href="tel:8502192273">(850) 219-2273</a> to see if we accept your insurance.</p>
          <p className="controlled-substance-note">Who are subscribe controlled substance: you must be seen once every 3 month in-order for the pharmacies to fill them, please make sure you are complaint with this so that it does not interrupt you medications.</p>
        </section>

        <section className="telehealth-section">
          <p>Please reach out to your insurance company to see if telehealth is covered and if so for how many. Insurances are no longer covering telehealth for every visit, most/all insurance are now requiring that you be seen at least once to twice a year in person, all new patients must be seen in person also per the new guideline.</p>
        </section>

        <section className="insurance-info-section">
          <p>As mental health gains greater acceptance in today's society, more and more people are thankfully getting the help they need—and insurance providers are meeting this demand with an ever-expanding range of therapies covered by their plans.</p>
          
          <p>Traditional mental health options rely on psychotherapy and psychiatric medication. Two prevalent examples of this are in the fields of depression and OCD, with psychiatrists opting for antidepressants such as selective serotonin reuptake inhibitors (SSRIs) to enhance the neurotransmitter's effect on a person's well-being. However, since a great many patients battling either disorder are found to be resistant to such medications or experience severe side effects, more and more additional treatments are now being considered.</p>
          
          <p>TMS is covered by insurance providers differently around the world, but has strong acceptance for treating major depressive disorder (MDD), which in the U.S. has been FDA cleared since 2013. In more recent developments, Deep TMS was FDA-cleared to treat obsessive-compulsive disorder (OCD) in 2018, and smoking cessation in 2020.</p>
          
          <p>Where covered by insurance, patients will typically incur the co-pay per treatment session dictated by their insurance plan. Where not covered by insurance, patients should speak with their mental health provider regarding payment options, or in some cases opportunities to create single case agreements with their insurance company to cover the treatment cost.</p>
          
          <p>Deep TMS has never been more widely accepted—and readily available—for those who might benefit from it.</p>
        </section>

        <section className="insurance-logos-section">
          <h3>Accepted Insurance Companies</h3>
          <div className="insurance-logos-grid">
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-1.jpg" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-5.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-7.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-9.jpg" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
            <div className="insurance-logo-item">
              <img src="/assets/images/Logo-10.png" alt="Insurance Company Logo" className="insurance-logo" />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default InsuranceInfo;

